// extracted by mini-css-extract-plugin
module.exports = {"CurrentPathDisplayContainer":"CurrentPathDisplay_CurrentPathDisplayContainer__1pc_3"};